/* Andrina Yvette - top bar message rotation (31 Aug 2026)

   A phone gives the top bar about 315px on one line, which fits one message,
   not two. Rather than drop the delivery promise on mobile, the bar alternates
   between the two cities and the delivery line every 5 seconds with a soft
   fade. The bar stays 62px tall and both messages get read.

   Desktop and tablet are untouched - all three items sit side by side there.

   Without JavaScript, or with reduced motion turned on, the cities stay put
   and nothing moves. The CSS default is the cities visible, so a failure here
   degrades to exactly what the bar showed before. */

(function () {
  var INTERVAL = 5000;

  function init() {
    var wrap = document.querySelector('.bwp-header-topbar .content-item-text-with-icon .custom-text');
    if (!wrap) return;

    var cities = wrap.querySelector('.text-icon1');
    var delivery = wrap.querySelector('.text-icon3');
    if (!cities || !delivery) return;

    var small = window.matchMedia('(max-width: 767px)');
    var still = window.matchMedia('(prefers-reduced-motion: reduce)');
    var timer = null;
    var showingDelivery = false;

    function paint() {
      cities.classList.toggle('ay-tb-out', showingDelivery);
      delivery.classList.toggle('ay-tb-in', showingDelivery);
    }

    function reset() {
      showingDelivery = false;
      paint();
    }

    function tick() {
      if (document.hidden) return;
      showingDelivery = !showingDelivery;
      paint();
    }

    function sync() {
      var shouldRun = small.matches && !still.matches;
      if (shouldRun && !timer) {
        timer = setInterval(tick, INTERVAL);
      } else if (!shouldRun && timer) {
        clearInterval(timer);
        timer = null;
        reset();
      }
    }

    function listen(mq) {
      if (mq.addEventListener) { mq.addEventListener('change', sync); }
      else if (mq.addListener) { mq.addListener(sync); }
    }

    listen(small);
    listen(still);
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
